import {IEnumListEntry} from "../definitions";
export const MODIFIER_TYPES = {
    ACTION_TIME: 1,
    ACTION_INCOME: 2,
    NOT_WORKING: 3,
    ACCELERATE_COST: 4,
    ACTION_TIME_FIXED: 5,
    EXPLOSION: 6
};


export const MODIFIERS_TYPES_LIST:IEnumListEntry[]= [
    { id: MODIFIER_TYPES.ACTION_TIME, label: "ACTION TIME" },
    { id: MODIFIER_TYPES.ACTION_INCOME, label: "ACTION INCOME" },
    { id: MODIFIER_TYPES.NOT_WORKING, label: "NOT WORKING" },
    { id: MODIFIER_TYPES.ACCELERATE_COST, label: "ACCELERATE COST" },
    { id: MODIFIER_TYPES.ACTION_TIME_FIXED, label: "ACTION_TIME_FIXED" },
    { id: MODIFIER_TYPES.EXPLOSION, label: "EXPLOSION" }
];



// WEBPACK FOOTER //
// /opt/app/develop/src/app/enums/e-modifiers.ts